import { cn } from '@mntn-dev/ui-utilities'

import { useSizing } from '../../hooks/use-sizing.ts'
import type { SkeletonProps } from './types.ts'

const Skeleton = ({
  variant,
  className,
  ...props
}: SkeletonProps & { variant: 'rectangle' | 'rounded' }) => {
  const sizing = useSizing({
    ...props,
  })

  return (
    <div
      className={cn(
        `${variant === 'rounded' ? 'rounded-full' : null} bg-white/90`,
        ...Object.values(sizing),
        className
      )}
    />
  )
}

export { Skeleton }
